import { OverlayContainer } from '@angular/cdk/overlay';
import { Directive, ElementRef, inject } from '@angular/core';

import { ContextTooltipContainerDirectiveToken } from '../consts';
import { ContextTooltipOverlay } from './context-tooltip-overlay';
import { ContextTooltipOverlayContainer } from './context-tooltip-overlay-container';

@Directive({
  selector: '[rtWysiwygContextTooltipContainer]',
  providers: [
    ContextTooltipOverlay,
    ContextTooltipOverlayContainer,
    {
      provide: OverlayContainer,
      useExisting: ContextTooltipOverlayContainer,
    },
    {
      provide: ContextTooltipContainerDirectiveToken,
      useExisting: ContextTooltipContainerDirective,
    },
  ],
  standalone: true,
})
export class ContextTooltipContainerDirective implements ContextTooltipContainerDirectiveToken {
  private readonly elRef = inject(ElementRef);

  public container: HTMLElement;

  constructor() {
    const directiveEl: HTMLElement = this.elRef.nativeElement;
    this.container = document.createElement('div');
    this.container.classList.add('cdk-overlay-container');
    this.container.style.zIndex = '1';
    this.container.style.position = 'absolute';
    this.container.style.overflow = 'hidden';
    directiveEl.appendChild(this.container);
  }
}
